import 'lazysizes';
import 'focus-visible';
import 'element-closest-polyfill';
import './polyfills/custom-event';
import './polyfills/prepend';
import objectFitImages from 'object-fit-images';
import create from '@verndale/core';
import LandrysForm from './modules/landrysForm';
import modules from './modules';

const FormLoadEvent = new window.CustomEvent('initFormComponents', {
  bubbles: true,
  cancelable: true
});

window.landrys = {
  initFormComponents: () => window.dispatchEvent(FormLoadEvent)
};

const scrollToHash = () => {
  const { hash } = location;

  if (hash) {
    const anchor = document.querySelector(hash);

    if (anchor) {
      try {
        window.scrollTo(0, 0);
        setTimeout(() => window.scrollTo(0, 0), 1);
        setTimeout(() => {
          const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          const { top } = anchor.getBoundingClientRect();
          const offset = 55;

          window.scrollTo({ top: scrollTop + top - offset });
        }, 700);
      } catch (e) {
        console.log('An error ocurred when scrolling to anchor.');
      }
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  objectFitImages();
  create(modules);

  document
    .querySelectorAll('.landrys-form')
    .forEach(form => new LandrysForm(form));

  // Check if there is a hash in the url and scroll to that element
  scrollToHash(true);

  // Fix misuse of four-column-grid module
  [...document.querySelectorAll('.four-column-grid')].forEach(module => {
    const hasContentCard = !!module.querySelector('.content-card');

    if (hasContentCard) {
      module.classList.add('four-column-grid--content-cards');
    }
  });
});
